import React from "react";
import { Avatar, CardHeader } from "@material-ui/core";

import truncateString from "../../utils/truncateString";
import WhatsappOfficialImg from "../../assets/miscJpg/whatsappOfficial.jpg";

import DefaultValuesUtils from "../../utils/classes/DefaultValuesUtils";

const ChatInfo = ({ contact }) => {
  //  ***************
  //  ** Functions **
  //  ***************
  const renderCardHeaderTitle = () => {
    return truncateString(contact?.name, 27);
  };



  //  ************
  //  ** Return **
  //  ************
  return (
    <CardHeader
      titleTypographyProps={{ noWrap: true }}
      subheaderTypographyProps={{ noWrap: true }}
      avatar={<Avatar src={contact?.name === DefaultValuesUtils.SPECIAL_NAMES.whatsapp ? WhatsappOfficialImg : contact?.profilePicUrl} alt="contact_image" />}
      title={contact?.name ? renderCardHeaderTitle() : ""}
    />
  );
};

export default ChatInfo;